<script>
  import { onMount } from "svelte";
  import { gameIcons, loadGameIcons, ICON_VIEWBOX } from "./lib/stickers.js";

  export let selected = false;
  export let interactable = true;
  export let x;
  export let y;
  export let icon;
  export let sizeRem;
  export let rotationDeg;
  export let anchor = "c";
  export let scale = 1.0;
  export let color = "#ffffff";

  let offsetX;
  let offsetY;

  let w;
  let h;

  // Placed stickers may render before the icon set has loaded (e.g. from a
  // shared URL), so pull it in on mount; the fetch is idempotent.
  onMount(loadGameIcons);

  $: body = $gameIcons ? $gameIcons.icons[icon] : null;

  $: if (anchor === "nw" || anchor === "w" || anchor === "sw") {
    offsetX = 0;
  } else if (anchor === "n" || anchor === "c" || anchor === "s") {
    offsetX = -w / 2;
  } else if (anchor === "ne" || anchor === "e" || anchor === "se") {
    offsetX = -w;
  }

  $: if (anchor === "nw" || anchor === "n" || anchor === "ne") {
    offsetY = 0;
  } else if (anchor === "w" || anchor === "c" || anchor === "e") {
    offsetY = -h / 2;
  } else if (anchor === "sw" || anchor === "s" || anchor === "se") {
    offsetY = -h;
  }
</script>

<div
  class:selected
  class:interactable
  on:pointerdown
  bind:clientWidth={w}
  bind:clientHeight={h}
  style="transform: translate({x + offsetX}px, {y + offsetY}px) rotate({rotationDeg}deg) scale({scale});"
>
  {#if body}
    <svg
      viewBox={ICON_VIEWBOX}
      style="width: {sizeRem}rem; height: {sizeRem}rem; color: {color}; fill: {color};"
    >
      {@html body}
    </svg>
  {/if}
</div>

<style>
  div {
    position: absolute;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    border: 2px solid transparent;
    padding: 5px;
    pointer-events: none;
    line-height: 0;
  }
  svg {
    display: block;
    /* game-icons bodies use fill="currentColor", so color drives the icon */
    color: white;
    fill: white;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 1));
  }
  div.interactable {
    pointer-events: auto;
    border-color: rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
  }
  div:hover {
    border-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);
  }
  div.selected {
    border-color: rgba(0, 64, 128, 1);
    box-shadow: 0 0 10px rgba(0, 128, 255, 1);
    background: rgba(0, 128, 255, 0.2);
  }
</style>
